const CONVERT_METHOD = 'convert-method';

const TTS_GUIDE = {
  ENTER_TEXT_HERE: 'editor-wrapper',
  UPLOAD_FILE_OR_IMPORT_URL: 'upload-file-or-import-url',
  VOICE: 'voice',
  TRY_LISTENING: 'try-listening',
  CONVERT: 'convert-tts',
  REQUESTS_TABLE: 'requests-table',
};

const DICTIONARY_GUIDE = {
  DICTIONARY_BTN: 'dictionary-button',
};

const TTS_TOUR_GUIDE = 'tts-tour-guide';

const PAYMENT_TOUR_GUIDE = {
  title: 'payment-tour-guide',
  CHOOSE_PAYMENT_METHOD: {
    title: 'choosePaymentMethod',
    content: 'choosePaymentMethodContentTourGuide',
  },
  USE_VOUCHER: {
    title: 'useVoucher',
    content: 'useVoucherContentTourGuide',
  },
  EXPORT_INVOICE: {
    title: 'exportInvoice',
    content: 'exportInvoiceTourGuide',
  },
  MAKE_PAYMENT: {
    title: 'makePayment',
    content: 'makePaymentTourGuide',
  },
};

const TOUR_GUIDE_TYPE = {
  PAYMENT_TOUR_GUIDE: 'payment-tour-guide',
};

const STEPS_TTS_GUIDE = [
  {
    title: 'textInput',
    steps: [
      { name: 'enterContentHere', target: `#${TTS_GUIDE.ENTER_TEXT_HERE}` },
    ],
  },
  {
    title: 'chooseVoiceGuide',
    steps: [
      {
        name: 'voiceAdjustmentGuide',
        target: `#${TTS_GUIDE.VOICE}`,
      },
    ],
  },
  {
    title: 'textTransfer',
    steps: [{ name: 'convertTTSGuide', target: `#${TTS_GUIDE.CONVERT}` }],
  },
  {
    title: 'historyRequest',
    steps: [
      {
        name: 'timeRequestGuide',
        target: `#${TTS_GUIDE.REQUESTS_TABLE}`,
      },
    ],
  },
];

const STEPS_ENTER_TEXT_HERE_GUIDE = [
  {
    title: 'enterTextHere',
    steps: [
      { name: 'enterContentHere', target: `#${TTS_GUIDE.ENTER_TEXT_HERE}` },
    ],
  },
];

export {
  CONVERT_METHOD,
  TTS_GUIDE,
  TTS_TOUR_GUIDE,
  PAYMENT_TOUR_GUIDE,
  TOUR_GUIDE_TYPE,
  DICTIONARY_GUIDE,
  STEPS_TTS_GUIDE,
  STEPS_ENTER_TEXT_HERE_GUIDE,
};
